var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleChecked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0667 22.75C25.1167 21.8833 22.7167 21.25 20 21.25C17.2833 21.25 14.8833 21.9 12.9333 22.75C11.1333 23.55 10 25.35 10 27.3167V30H30V27.3167C30 25.35 28.8667 23.55 27.0667 22.75Z",
    fill: "#204377"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.03333 24.3C0.8 24.8333 0 26.0333 0 27.3833V30H7.5V27.3167C7.5 25.9333 7.88333 24.6333 8.55 23.5C7.93333 23.4 7.31667 23.3333 6.66667 23.3333C5.01667 23.3333 3.45 23.6833 2.03333 24.3Z",
    fill: "#204377"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9667 24.3C36.55 23.6833 34.9833 23.3333 33.3333 23.3333C32.6833 23.3333 32.0667 23.4 31.45 23.5C32.1167 24.6333 32.5 25.9333 32.5 27.3167V30H40V27.3833C40 26.0333 39.2 24.8333 37.9667 24.3Z",
    fill: "#204377"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 20C22.7667 20 25 17.7667 25 15C25 12.2333 22.7667 10 20 10C17.2333 10 15 12.2333 15 15C15 17.7667 17.2333 20 20 20Z",
    fill: "#204377"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 14.1614L2.49461 18.3333L6.6665 22.5052L10.8384 18.3333L6.6665 14.1614Z",
    fill: "#204377"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 15L29.1667 21.6667H37.5L33.3333 15Z",
    fill: "#204377"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleChecked);
export default __webpack_public_path__ + "static/media/people_checked.18220a6e43e8cb3c573c6207ca5792a9.svg";
export { ForwardRef as ReactComponent };